export default "### Low deposit loans\n\nMinimum $500, subject to status.\n";